import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { warningsEvent } from '../../lib/response-feedback';
import { workflowValue } from '../../lib/workflows/repository';
import type { Value } from '../../lib/workflows/types';
import { Evidence } from './Evidence';
import { Button } from '../ui/button';
export function OperationNotices() {
  const [warnings, setWarnings] = useState<Value>(null),
    location = useLocation();
  useEffect(() => setWarnings(null), [location.pathname, location.search]);
  useEffect(() => {
    const receive = (event: Event) => {
      if (event instanceof CustomEvent) {
        try {
          setWarnings(workflowValue(event.detail));
        } catch {
          /* Invalid feedback cannot change the operation outcome. */
        }
      }
    };
    window.addEventListener(warningsEvent, receive);
    return () => window.removeEventListener(warningsEvent, receive);
  }, []);
  return warnings === null ? null : (
    <aside role="status" className="mt-4 rounded-panel border border-warning/40 bg-card p-4">
      <div className="flex items-center justify-between gap-3">
        <strong>Operation completed with warnings</strong>
        <Button variant="ghost" onClick={() => setWarnings(null)}>
          Dismiss
        </Button>
      </div>
      <details>
        <summary className="cursor-pointer text-primary">Review warnings</summary>
        <Evidence value={warnings} />
      </details>
    </aside>
  );
}
